export interface ButtonCallback {
  // eslint-disable-next-line
  (button: Button): Promise<void>;
}

export default class Button {
  public show: boolean;
  public label: string;
  public type: string;
  public disabled: boolean;
  public outlined: boolean;
  public loading: boolean;
  public callback: ButtonCallback;
}
